import request from '../utils/request'

/**
 * 获取审批列表（通用，管理员/会计/内勤）
 */
export function getApprovalList(params) {
  return request({
    url: '/manager/approval/list',
    method: 'get',
    params
  })
}

/**
 * 获取待审批数量（通用，支持内勤、会计、管理员）
 */
export function getPendingApprovalCount() {
  return request({
    url: '/manager/approval/pending-count',
    method: 'get'
  })
}

/**
 * 更新审批状态（通过/拒绝，通用接口，支持内勤、会计、管理员）
 */
export function updateApprovalStatus(data) {
  return request({
    url: '/manager/approval/update-status',
    method: 'post',
    data
  })
}

/**
 * 获取审批记录（时间轴，通用接口，支持内勤、会计、管理员）
 */
export function getApprovalRecords(params) {
  return request({
    url: '/manager/approval/records',
    method: 'get',
    params
  })
}

/**
 * 打开审批详情（将状态从PENDING改为APPROVING，通用接口，支持内勤、会计、管理员）
 */
export function openApprovalDetail(approvalId) {
  return request({
    url: '/manager/approval/open-detail',
    method: 'post',
    params: { approvalId }
  })
}

/**
 * 获取审批详情（包含审批节点信息，通用接口，支持内勤、会计、管理员）
 */
export function getApprovalDetail(approvalId) {
  return request({
    url: '/manager/approval/open-detail',
    method: 'post',
    params: { approvalId }
  })
}

/**
 * 获取业务详情（用于审批详情展示，支持内勤、会计、管理员）
 */
export function getBusinessDetail(businessType, businessId) {
  return request({
    url: '/manager/approval/business-detail',
    method: 'get',
    params: { businessType, businessId }
  })
}

